export const MASKS = {
  CPF: "999.999.999-99",
  CNPJ: "99.999.999/9999-99",
  /** Celular com 9º dígito: 5 antes do hífen, 4 depois. */
  PHONE_9: "+55 (99) 99999-9999",
  /** Fixo/legado sem 9º dígito: 4 antes do hífen, 4 depois. */
  PHONE_8: "+55 (99) 9999-9999",
  /** @deprecated Use BrazilPhoneMaskInput. */
  PHONE: "+55 (99) 99999-9999",
  ADDRESS: "99999-999",
};

export const DEFINITIONS = {
  CPF: {
    "9": /\d/,
  },

  CNPJ: {
    "9": /\d/,
  },

  ADDRESS: {
    "9": /\d/,
  },

  PHONE: {
    "9": /\d/,
  },
};
